import type { UseMutationOptions } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

import { QUERIES } from '@/enums/queries'
import type {
  CreateUpdateStripeIntegrationProps,
  StripeIntegration,
} from '@/types/stripe-integration'

import { addStripeIntegration } from './services/mutateStripeIntegration'
import { invalidateLoadStripeIntegrations } from './useLoadStripeIntegration'

export const useAddStripeIntegrations = (
  options?: Omit<
    UseMutationOptions<
      StripeIntegration,
      Error,
      CreateUpdateStripeIntegrationProps,
      unknown
    >,
    'mutationKey' | 'mutationFn' | 'onSuccess'
  >
) => {
  const mutation = useMutation({
    mutationKey: [QUERIES.INTEGRATIONS.STRIPE.ADD],
    mutationFn: async (data: CreateUpdateStripeIntegrationProps) =>
      await addStripeIntegration(data),
    onSuccess: async () => {
      await invalidateLoadStripeIntegrations()
    },
    ...options,
  })

  const addStripeIntegrationReq = async (
    data: CreateUpdateStripeIntegrationProps
  ) => {
    return mutation.mutateAsync(data)
  }

  return {
    addStripeIntegration: addStripeIntegrationReq,
    ...mutation,
  }
}
